import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
// import "./LateArrivals.css";

const data = {
  Today: [
    {
      name: "Jessica Brown",
      role: "Customer Support",
      time: "10:15 AM",
      delay: "+45 Min",
      img: "/assets/img/users/user-26.jpg",
    },
    {
      name: "Amanda Lewis",
      role: "HR Admin",
      time: "10:25 AM",
      delay: "+55 Min",
      img: "/assets/img/users/user-31.jpg",
    },
    {
      name: "James Clark",
      role: "Sales",
      time: "10:00 AM",
      delay: "+30 Min",
      img: "/assets/img/users/user-27-1.jpg",
    },
    {
      name: "Amanda Davis",
      role: "Administration",
      time: "09:40 AM",
      delay: "+20 Min",
      img: "/assets/img/users/user-56.jpg",
    },
    {
      name: "Lisa Anderson",
      role: "Finance",
      time: "09:35 AM",
      delay: "+05 Min",
      img: "/assets/img/users/user-29-1.jpg",
    },
  ],

  Weekly: [
    {
      name: "James Clark",
      role: "Sales",
      time: "09:50 AM",
      delay: "+20 Min",
      img: "/assets/img/users/user-27-1.jpg",
    },
    {
      name: "Amanda Davis",
      role: "Administration",
      time: "09:40 AM",
      delay: "+15 Min",
      img: "/assets/img/users/user-56.jpg",
    },
  ],

  Monthly: [
    {
      name: "Jessica Brown",
      role: "Customer Support",
      time: "10:15 AM",
      delay: "+45 Min",
      img: "/assets/img/users/user-26.jpg",
    },
  ],
};

const LateArrivals = () => {
  const [filter, setFilter] = useState("Today");

  return (
    <Card className="late-card">
      <Card.Body>

        {/* HEADER */}

        <div className="late-header">

          <h5 className="late-title">
            Late Arrivals Today
          </h5>

          <Dropdown>
            <Dropdown.Toggle className="late-dropdown">
              <FiCalendar className="me-2"/>
              {filter}
            </Dropdown.Toggle>

            <Dropdown.Menu>

              <Dropdown.Item onClick={() => setFilter("Monthly")}>
                Monthly
              </Dropdown.Item>

              <Dropdown.Item onClick={() => setFilter("Weekly")}>
                Weekly
              </Dropdown.Item>

              <Dropdown.Item onClick={() => setFilter("Today")}>
                Today
              </Dropdown.Item>

            </Dropdown.Menu>
          </Dropdown>

        </div>

        {/* USERS */}

        {data[filter].map((user, index) => (

          <div key={index} className="late-user">

            <div className="late-left">

              <img
                src={user.img}
                alt=""
                className="late-avatar"
              />

              <div>

                <p className="late-name">
                  {user.name}
                </p>

                <p className="late-role">
                  {user.role}
                </p>

              </div>

            </div>

            <div className="late-right">

              <p className="late-time">
                {user.time}
              </p>

              <span className="late-badge">
                {user.delay}
              </span>

            </div>

          </div>

        ))}

      </Card.Body>
      <style>


          {
               `
               .late-card {
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}

/* HEADER */

.late-header {
  border: 1px solid #e5e7eb;
  border-left: 4px solid #ff6b2c;
  border-radius: 8px;
  padding: 10px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.late-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.late-dropdown {
  background: white !important;
  border: 1px solid #e5e7eb !important;
  color: #111;
  font-size: 14px;
}

/* USER CARD */

.late-user {
  background: #f8fafc;
  border-radius: 8px;
  padding: 10px 12px;
  border-bottom: 1px solid #edf0f3;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

/* LEFT */

.late-left {
  display: flex;
  align-items: center;
}

.late-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  margin-right: 10px;
}

/* TEXT */

.late-name {
  font-size: 14px;
  font-weight: 600;
  margin: 0;
}

.late-role {
  font-size: 13px;
  color: #6b7280;
  margin: 0;
}

/* RIGHT */

.late-right {
  text-align: right;
}

.late-time {
  font-size: 13px;
  margin-bottom: 3px;
}

/* BADGE */

.late-badge {
  background: #ffe4e4;
  color: #ff3b3b;
  font-size: 12px;
  padding: 3px 10px;
  border-radius: 20px;
}
               `
          }
      </style>
    </Card>
  );
};

export default LateArrivals;